import * as $ from "jquery";
import "gsap/TweenLite";
import "gsap/CSSPlugin";
import { throttle, debounce } from "throttle-debounce";
import * as Stickyfill from "stickyfilljs";
import * as scrollama from "scrollama";
import * as Modernizr from "../../lib/modernizr-3.5.0.min.js";
import slugify from "slugify";

declare var TweenLite: any;

// Used by left/right scroll buttons
enum ScrollDirections {
	LEFT = 1,
	RIGHT = -1
};

// Support for older browsers that don't support position: sticky
function applyPolyfills() {
	let elements = $('.js-sticky');
	Stickyfill.add(elements);
}

/**
 * Determines whether the selected tab / link is completely visible inside the nav list. If it is, we won't bother recentering
 * @param el
 * @param list
 * @returns {boolean}
 */
function isTriggerElementInViewport(el, list) {
	let $el = $(el);
	let elLeft = $el.offset().left;
	let elRight = elLeft + $el.outerWidth(true);

	return (elLeft >= 0) && elRight <= list.offsetWidth;
}

/**
 * Re-centers the nav list on the selected element as the user scrolls
 * @param el
 */
function centerOnElement(el) {
	let navList = $('.js-section-nav-list').get(0);
	let $navList = $(navList);
	let $nav = $navList.parent();
	let $el = $(el);
	let $listItem = $el.parent();

	let listPos = 0;
	let elPos = $listItem.get(0).offsetLeft;
	let elWidth = $listItem.width();
	let navWidth = $nav.width();

	// If there's a selected item
	if($el.length !== 0) {
		if (Modernizr.mq('(max-width: 767px)')) {
			// Mobile operation: keep it centered
			listPos = -elPos + (navWidth / 2) - (elWidth / 2);
		} else {
			// Normal operation: constrain within bounds
			// if the element is already fully visible, bail
			if (isTriggerElementInViewport(el, navList)) { return; }
		}

		// Try to line up the left edge of the selected item with the left edge of the container. This may not be possible
		// if the selected item is close to the right or left edge of the list
		let xMin = -(navList.scrollWidth - navList.offsetWidth);
		let xMax = 0;

		listPos = -elPos + (navWidth / 2) - (elWidth / 2);
		listPos = Math.max(xMin, listPos);
		listPos = Math.min(xMax, listPos);

		TweenLite.set(navList, {
			x: listPos,
			onComplete: function () {
				// When the animation finishes, update the left/right nav buttons according to our new position in the list
				updateNavButtons(navList);
			}
		});
	}
}

/**
 * Animate the list left or right when the left/right buttons are clicked
 * @param dir
 */
function animateList(navList, dir) {
	let $navList = $(navList);
	let stepWidth = window.innerWidth / 3;  // Animate by 1/3 the screen width at at time
	navList = $navList.get(0);

	// There's no CSS/DOM property to access an item's translateX transform value.
	// navList._gsTransform is TweenLite's internal variable for keeping track of that.
	// dir is determined by whether the left or right button was clicked. See the ScrollDirections enum above.
	let newX = (navList._gsTransform ? navList._gsTransform.x : 0) + (stepWidth * dir);

	// Prevent the list from coming unglued from the left or right edges of the container
	let xMin = -(navList.scrollWidth - navList.offsetWidth);
	let xMax = 0;
	newX = Math.max(xMin, newX);
	newX = Math.min(xMax, newX);

	TweenLite.to($navList, 0.35, {
		x: newX,
		onComplete: function () {
			// When the animation finishes, update the left/right nav buttons according to our new position in the list
			updateNavButtons(navList);
		}
	});
}

/**
 * Check the list's current position within its container and enable or disable the nav buttons accordingly
 * @param navList
 */
function updateNavButtons(navList) {
	let $navList = $(navList);
	navList = $navList.get(0);
	let $nav = $navList.closest('.js-section-nav');
	let $leftBtn = $nav.find('.js-section-nav-left');
	let $rightBtn = $nav.find('.js-section-nav-right');

	// Prevent the list from coming unglued from the left or right edges of the container
	let xMin = -(navList.scrollWidth - navList.offsetWidth);
	let xMax = 0;

	// There's no CSS/DOM property to access an item's translateX transform value.
	// navList._gsTransform is TweenLite's internal variable for keeping track of that.
	let currX = navList._gsTransform ? navList._gsTransform.x : 0;

	if (currX >= xMax) {
		// If we're at the left edge of the list, hide the left button
		$leftBtn.removeClass('state-visible');
	} else {
		// Otherwise show it
		$leftBtn.addClass('state-visible');
	}

	if (currX <= xMin) {
		// If we're at the right edge of the list, hide the right button
		$rightBtn.removeClass('state-visible');
	} else {
		// Otherwise show it
		$rightBtn.addClass('state-visible');
	}
}

/**
 * Checks to see if the navList is wider than its container. If it is not, center the list so it doesn't stick
 * awkwardly to the left edge of the screen
 * @param navList
 */
function updateNavListCentering(navList){
	let $navList = $(navList);
	let $nav = $navList.closest('.js-section-nav');

	if(navList.scrollWidth <= navList.offsetWidth) {
		$nav.addClass('section-nav--centered');
	} else {
		$nav.removeClass('section-nav--centered');
	}

	if (!$navList.hasClass('state-visible')) {
		$navList.addClass('state-visible');
	}
}

/**
 * Enables "scroll spy" functionality, i.e. highlighting the currently-viewed section as we scroll down the page
 */
function initScrollSpy() {
	// initialize the scrollama (or grab a reference if one already exists - this seems to be a Singleton)
	var scrollSpyHandler = scrollama();

	function handleStepEnter(response) {
		//when an element enters into the scollama view range, get the element's data-section attribute value
		var theSection = $(response.element).attr('data-section');

		//then we find the matching navigation item whose data-target matches data-section value
		//we just stored and add a .state-active class
		let $newNavItem = $('a[data-target="'+theSection+'"]');

		if ($newNavItem.length) {
			// Remove state-active from any currently active section-nav triggers
			$('.js-section-trigger').each(function() {
				$(this).parent().removeClass('state-active');
			});

			$newNavItem.parent().addClass('state-active');
			centerOnElement($newNavItem);
		}
	}

	if ($('[data-section], [data-sf-element="Section Nav"]').length) {
		scrollSpyHandler.setup({
			step: '[data-section], [data-sf-element="Section Nav"]',
			offset: 0.25
		}).onStepEnter(handleStepEnter)
			.onStepProgress(function () {
				// console.log(arguments);
			});
	}

	$(window).on('resize', function() {
		scrollSpyHandler.resize();
	});

	if(window.location.hash) {
		var hash = window.location.hash.substring(1);
		$("a[data-target=" + hash + " i]").click();
	}

}

/**
 * Initialize section nav resize handling
 */
function initLists() {
	$('.js-section-nav-list').each(function () {
		updateNavButtons(this);
		updateNavListCentering(this);
	});

	$(window).on('resize', throttle(300, function () {
		$('.js-section-nav-list').each(function() {
			updateNavButtons($(this));
			updateNavListCentering(this);

			// Return to the beginning of the list
			TweenLite.set(this, {
				x: 0
			});
		});
	}));
}

/**
 * Enables the scroll left/scroll right buttons
 */
function initLeftRightButtons() {
	$('.js-section-nav-btn').on('click', function () {
		let $btn = $(this);
		let dir = $btn.hasClass('js-section-nav-left') ? ScrollDirections.LEFT : ScrollDirections.RIGHT;
		let navList = $btn.closest('.js-section-nav').find('.js-section-nav-list').get(0);
		animateList(navList, dir);
	});
}

/**
 * Makes clicking trigger links in the section nav list jump to that section
 */
function initTriggerButtons() {
	$('.js-section-trigger').on('click', function(e) {
		var $this = $(this);
		var dataTarget = $(this).attr('data-target');
		var $target = $(`[data-section="${dataTarget}"]`);
		$('.js-section-trigger').removeClass('state-active');

		$this.addClass('state-active');

		if ($target.length) {
			$('html, body').stop().animate({
				scrollTop: ( $target.offset().top - ($('.js-section-nav').height()) ) + 5
			}, 800);
		}

		e.preventDefault();
	});
}

/**
 * Section navs with the [data-load-sections] attribute will construct their own list of nav triggers by scanning the
 * DOM For all elements with a [data-section] attribute
 */
function autoLoadSections() {
	// Be aware: Auto-loading works best if there's a single sectionNav on the page. If there are multiple, things might get funky
	let $navList = $('.js-section-nav[data-load-sections]').find('.js-section-nav-list');

	function constructItem(item: any) {
		let itemTemplate = `<li class="section-nav__item">
			<a href="#" class="section-nav__trigger js-section-trigger" data-target="${item.sectionName}">${item.title}</a>
		</li>`;
		return $(itemTemplate);
	}

	let sectionNames = [];

	/**
	 * Make sure that two sections in the nav don't have the same data-section attribute
	 * @param {string} sectionName
	 * @returns {string}
	 */
	function ensureUnique(sectionName: string): string {
		for (let nextName of sectionNames) {
			if (nextName === sectionName) {
				// If there's already a section by this name, add a "-" and the current Unix timestamp
				sectionName = sectionName + (new Date().getTime());
				break;
			}
		}

		return sectionName;
	}

	$('[data-section]:not(body), [data-sf-element="Section Nav"]').each(function () {
		let $this = $(this);

		let title = '';
		if ($this.data('title') && $this.data('title') !== '') {
			title = $this.data('title');
		} else if ($this.data('placeholder-label') && $this.data('placeholder-label') !== '') {
			title = $this.data('placeholder-label');
		} else if ($this.find('h1, h2, h3').length) {
			title = $(this).find('h1, h2, h3').eq(0).text();
		}

		let sectionName = '';
		if ($this.data('section') && $this.data('section') !== "Section-Title") {
			sectionName = $this.data('section');
		} else {
			sectionName = ensureUnique(slugify($this.data('placeholder-label') || title));
			$this.attr('data-section', sectionName);
		}

		let item = {
			sectionName: sectionName,
			title: title
		};

		$navList.append( constructItem(item) );
	})
}

function setupAbsoluteVersion(instance) {
	var $this = instance;

	function checkScrollPosition(){
		if( $(window).scrollTop() >= $this.offset().top ) {
			$this.addClass('section-nav--white');
		} else {
			$this.removeClass('section-nav--white');
		}
	}

	checkScrollPosition();

	$(window).on('scroll', throttle(300, function () {
		checkScrollPosition();
	}));
}

export function init() {
	if ( $('.js-section-nav').length ) {

		if ( $('.js-section-nav[data-load-sections]').length ) {
			autoLoadSections();
		}

		applyPolyfills();
		initLists();
		initLeftRightButtons();
		initTriggerButtons();

		if ( $('.js-section-nav[data-scroll-spy]').length ) {
			initScrollSpy();
		}

		if($('.js-section-nav-absolute').length) {
			setupAbsoluteVersion($('.js-section-nav-absolute'));
		}
	}
}



// WEBPACK FOOTER //
// ./js/PFF/modules/SectionNav.ts